import React, { useState } from 'react';
import classNames from 'classnames';
import { Icon, IconsEnum } from 'components/Icons';
import { Modal } from 'components/modals/components/modal';
import styles from '../ScommesseFiltersListScrollable.module.scss';
import { ScommessaButton, ScommesseFiltersListScrollableTypeExtendProps } from 'components/scommesseFiltersListScrollable/ScommesseFiltersListScrollable';
import { useBlockScroll } from 'hooks/useBlockScroll';
import { useSharedState } from 'components/scommesseFiltersListScrollable/hooks/hooks';
import { useTranslation } from 'hooks/useLingUI';

type ViewAllButtonProps = Pick<
  ScommesseFiltersListScrollableTypeExtendProps,
  'headerModalLabel' | 'list' | 'subHeaderModalLabel'
>;

export const ViewAllButton = ({ list, headerModalLabel, subHeaderModalLabel }: ViewAllButtonProps) => {
  const [showModal, setShowModal] = useState(false);

  const openModal = () => {
    setShowModal(true);
  };

  return (
    <React.Fragment>
      <button className={classNames(styles.button, styles.viewAllButton)} onClick={() => openModal()}>
        <Icon iconId={IconsEnum.PLUS} className={styles.icon} />
        <span>vedi tutte</span>
      </button>
      {showModal && (
        <Modal
          modalType={'fullheight'}
          modalCategory={'filters'}
          showCloseButton={false}
          overlayClassName={styles.fullHeightModal}
        >
          <AllListModalContent
            list={list}
            onClose={() => setShowModal(false)}
            headerModalLabel={headerModalLabel}
            subHeaderModalLabel={subHeaderModalLabel}
          />
        </Modal>
      )}
    </React.Fragment>
  );
};

type AllModalContentProps = {
  list: Array<ScommessaButton>;
  onClose: () => void;
} & Pick<ScommesseFiltersListScrollableTypeExtendProps, 'headerModalLabel' | 'subHeaderModalLabel'>;

export const AllListModalContent = ({ onClose, list, headerModalLabel, subHeaderModalLabel }: AllModalContentProps) => {
  const { state: selectedButton, setState } = useSharedState()!;
  useBlockScroll();
  const { t } = useTranslation();

  return (
    <div className={styles.modal}>
      <div className={styles.modalHeader}>
        <h3>{headerModalLabel}</h3>
        <Icon iconId={IconsEnum.CLOSE} className={styles.icon} onClick={onClose} />
      </div>
      {subHeaderModalLabel && (
        <div className={styles.modalSubheader}>
          <h4>{subHeaderModalLabel}</h4>
        </div>
      )}
      <div className={styles.modalList}>
        {list.map((item, index) => {
          return (
            <button
              suppressHydrationWarning
              key={index}
              className={classNames(styles.button, [
                {
                  [styles.inactive]: selectedButton !== index,
                  [styles.white]: selectedButton === index,
                },
              ])}
              onClick={() => {
                setState(index);
                onClose();
              }}
            >
              {t(item.labelTrKey, item.label)}
            </button>
          );
        })}
      </div>
    </div>
  );
};